import QRCode from "qrcode";
window.makeQrCode = function(text, id) {


  QRCode.toCanvas(document.getElementById(id), text,{
    width: 250,
    height: 250,
  }, function (error) {
    if (error) {
        console.log(error);
    }else{

    }
  });

}

window.apiClient = axios.create({
    baseURL: '',
    withCredentials: true,
    crossDomain: true,
    headers: {
        "content-type": "application/json"
    }
});

window.globalCopy = function(id) {
  var copyText = document.querySelector(id);
  copyText.select();
  document.execCommand("copy");
}

window.loadGlobal = function(status) {
  if(status){
    $('body').append('<div class="load-bg"><div class="load-img"></div></div>');
    if($(window).width()<=768){
      document.body.style.overflow = 'hidden';
    }
  }else{
    $('.load-bg').remove();
    document.body.style.overflow = 'auto';
  }
}

window._loadGlobal = function(status) {
  if (status) {
      // Criar os elementos div para o fundo e a imagem de carregamento
      var loadBgDiv = document.createElement('div');
      loadBgDiv.className = 'load-bg';
      var loadImgDiv = document.createElement('div');
      loadImgDiv.className = 'load-img';

      // Anexar a div da imagem à div de fundo e depois ao body
      loadBgDiv.appendChild(loadImgDiv);
      document.body.appendChild(loadBgDiv);

      // Verificar a largura da janela e ajustar o overflow do body
      if (window.innerWidth <= 768) {
          document.body.style.overflow = 'hidden';
      }
  } else {
      // Remover o elemento com a classe 'load-bg'
      var loadBg = document.querySelector('.load-bg');
      if (loadBg) {
          loadBg.parentNode.removeChild(loadBg);
      }
      document.body.style.overflow = 'auto';
  }
};


window.HandlingError = function(error, validator){
    if (error.response) {
        if(error.response.status==422){
          //console.log(error.response.data.errors);
          validator.resetForm();
          try {
            validator.showErrors(error.response.data.errors);
          } catch (error) {
            //console.log(error);
          }

          
        }else{
          //console.log(error.response.data);
          //console.log(error.response.status);
          //console.log(error.response.headers);
        }
        
        
      } else if (error.request) {
        //console.log(error.request);
      } else {
        //console.log('Error', error.message);
      }
      //console.log(error.config);
};

window.decimalAdjust = function(type, value, exp) {
    //TODO: Remover esse primeiro trexo após identificar o problema da diferença nas casas decimais entre hero-admin e xavier
    var pow = Math.pow(10, exp);
    var scaledValue = value * pow;

    var thirdDecimal = (scaledValue % 1) * 10;

    if (type === 'round' && Math.abs(thirdDecimal - 5) < Number.EPSILON) {
        return (Math.floor(scaledValue) / pow);
    }


  // Se exp é indefinido ou zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // Se o valor não é um número ou o exp não é inteiro...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // Transformando para string
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Transformando de volta
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}


window.toFixed = function(num, fixed) {
  var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return num.toString().match(re)[0];
}

window.IOF = function(amount) {
  amount           = amount.replaceAll(/[^0-9,]+/g,"");
  amount           = amount.replaceAll(",",".");
  amount           = parseFloat(amount).toFixed(2);
  return decimalAdjust('round', amount * 0.0038,-6).toString();
}
window.calcSaida = function(premio, comissao) {

  premio           = premio.replaceAll(/[^0-9,]+/g,"");
  premio           = premio.replaceAll(",",".");
  premio           = parseFloat(premio).toFixed(2);

  var ganhoTotal   = premio;

  comissao         = comissao.replaceAll(/[^0-9.]+/g,"");
  comissao         = parseFloat(comissao);

  //precofinalBruto  = (premio/-(comissao-100)) * 100;
  precofinalBruto  = decimalAdjust('round', (premio/-(comissao-100)) * 100 ,-2);

  precofinal       = toFixed((precofinalBruto).toFixed(2), 2);

  ganhoTotal       = precofinal - ganhoTotal;

  precofinalIOF    = toFixed(decimalAdjust('round', precofinalBruto + (precofinalBruto * 0.0038),-6).toString(),2);
 
  return {
    'premio':premio, 
    'comissao':comissao, 
    'precofinal':precofinal, 
    'ganhoTotal':ganhoTotal.toFixed(2),
    'comIOF':precofinalIOF
  };
}

window.percentMask = function(el){
  IMask(el, {
      mask: [
          {
              mask: '00.0'
          }
      ],
  });
}

window.percentDoubleMask = function(el){
  IMask(el, {
      mask: [
          {
              mask: '00.00'
          }
      ],
  });
}
window.percentTriple = function(el){
  IMask(el, {
      mask: [
          {
              mask: '000.00'
          }
      ],
  });
}


window.currencyMask = function(el){
  IMask(el, {
      mask: [
          { mask: '' },
          {
              mask: 'num',
              lazy: false,
              blocks: {
                  num: {
                      mask: Number,
                      scale: 2,
                      thousandsSeparator: '.',
                      padFractionalZeros: true,
                      radix: ',',
                      mapToRadix: ['.'],
                  }
              }
          }
      ],
  });
}

$(function(){
  if($('.copy')[0]){
    $('.copy').on('click',function(){
      globalCopy($(this).data('id'));
    });
  }

  if($('.data-toggle')[0]){
    $('.data-toggle').each(function() {
      $('div[' + $( this ).data('toggle') + ']').hide();
    });
    $('.data-toggle:checked').each(function() {
      $('div[' + $( this ).data('toggle') + '=' + $( this ).val() + ']').show();
    });
    $('.data-toggle').on('click', function(){
      $('div[' + $( this ).data('toggle') + ']').hide();
      $('div[' + $( this ).data('toggle') + '=' + $(this).val() + ']').toggle()
    }); 
  }

  

});


